export function TypographyVariants() {
  return (
    <>
      <div className="text-center">
        <h1
      className="font-bold leading-snug tracking-tight text-slate-800 mx-auto my-6 w-full text-2xl lg:max-w-3xl lg:text-5xl"
      >
        H1 Get ready to experience a new level of performance and functionality.
      </h1>

      <h1
        className="font-light leading-snug tracking-tight text-slate-800 mx-auto my-6 w-full text-2xl lg:max-w-3xl lg:text-5xl"
      >
        H1 Get ready to experience a new level of performance and functionality.
      </h1>

    <h2
        className="font-bold leading-snug tracking-normal text-slate-800 mx-auto my-6 w-full text-2xl lg:max-w-3xl lg:text-4xl"
      >
        H2 Get ready to experience a new level of performance and functionality.
      </h2>

      <h2
        className="font-light leading-snug tracking-normal text-slate-800 mx-auto my-6 w-full text-2xl lg:max-w-3xl lg:text-4xl"
      >
        H2 Get ready to experience a new level of performance and functionality.
      </h2>


      <h3
        className="font-semibold leading-snug tracking-normal text-slate-800 mx-auto my-6 w-full text-xl max-w-lg lg:max-w-2xl lg:text-3xl"
      >
        H3 Get ready to experience a new level of performance and functionality.
      </h3>

      <h3
        className="font-light leading-snug tracking-normal text-slate-800 mx-auto my-6 w-full text-xl max-w-lg lg:max-w-2xl lg:text-3xl"
      >
        H3 Get ready to experience a new level of performance and functionality.
      </h3>



      <h4
        className="font-semibold leading-snug tracking-normal text-slate-800 mx-auto my-6 w-full text-lg max-w-md lg:max-w-xl lg:text-2xl"
      >
        H4 Get ready to experience a new level of performance and functionality.
      </h4>

      <h4
        className="font-light leading-snug tracking-normal text-slate-800 mx-auto my-6 w-full text-lg max-w-md lg:max-w-xl lg:text-2xl"
      >
        H4 Get ready to experience a new level of performance and functionality.
      </h4>



      <h5
        className="font-semibold leading-snug tracking-normal text-slate-800 mx-auto my-6 w-full text-base max-w-sm lg:max-w-lg lg:text-xl"
      >
        H5 Get ready to experience a new level of performance and functionality.
      </h5>

      <h5
        className="font-light leading-snug tracking-normal text-slate-800 mx-auto my-6 w-full text-base max-w-sm lg:max-w-lg lg:text-xl"
      >
        H5 Get ready to experience a new level of performance and functionality.
      </h5>


        <h6
        className="font-bold leading-snug tracking-normal text-slate-800 mx-auto my-6 w-full text-sm max-w-xs lg:max-w-md lg:text-lg"
      >
        H6 Get ready to experience a new level of performance and functionality.
      </h6>

      <h6
        className="font-light leading-snug tracking-normal text-slate-800 mx-auto my-6 w-full text-sm max-w-xs lg:max-w-md lg:text-lg"
      >
        H6 Get ready to experience a new level of performance and functionality.
      </h6>
      </div>
    </>
  );
}
